
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz/retake/questions",
      function () {
        return require("private-next-pages/quiz/retake/questions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz/retake/questions"])
      });
    }
  